import { render, staticRenderFns } from "./CreditLogs.vue?vue&type=template&id=152cc842&"
import script from "./CreditLogs.vue?vue&type=script&lang=js&"
export * from "./CreditLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports